import React from "react";
import BatchGrid from "../BatchGrid/BatchGrid";
import Header from "./Header/Header";

const Home = () => {
  return (
    <>
      <Header />
      <marquee>
        <blockquote> POS Batches:</blockquote>
      </marquee>
      <BatchGrid />
    </>
  );
};

export default Home;
